import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle, faTimesCircle, faDownload, faExclamation,
} from '@fortawesome/free-solid-svg-icons';
import styles from './LogDetail.module.less';

function getColumnsLogs({ t }) {

  return [
    {
      key: 'category',
      title: t('tables.logsDetail.columns.date'),
      dataIndex: 'category',
    },
    {
      title: t('tables.logsDetail.columns.Status'),
      width: 160,
      fixed: 'right',
      render: (_, record) => {

        const id = `category_${record.category}`;
        if (record.bit === 1) {

          return (
          // eslint-disable-next-line react/jsx-filename-extension
            <div key={id}>
              <FontAwesomeIcon
                className={styles.faOK}
                icon={faCheckCircle}
              />
            </div>
          );

        }
        if (record.bit === 2) {

          return (
          // eslint-disable-next-line react/jsx-filename-extension
            <div key={id}>
              <FontAwesomeIcon
                className={styles.faINFO}
                icon={faExclamation}
              />
            </div>
          );

        }
        if (record.bit === 3) {

          return (
          // eslint-disable-next-line react/jsx-filename-extension
            <div key={id}>
              <FontAwesomeIcon
                className={styles.faWARNING}
                icon={faDownload}
              />
            </div>
          );

        }

        return (
        // eslint-disable-next-line react/jsx-filename-extension
          <div key={id}>
            <FontAwesomeIcon
              className={styles.faERROR}
              icon={faTimesCircle}
            />
          </div>
        );

      },
    },
  ];

}

export default getColumnsLogs;
